// Mock data for Aventix Services Conseils website

export const companyInfo = {
  name: "Service Conseils Aventix inc.",
  tagline: "Expertise en gestion de projet TI et affaires",
  email: "info@aventix.com",
  phone: "(418) 559-0969",
  address: "Québec, QC, Canada",
  socialMedia: {
    linkedin: "http://www.linkedin.com/company/2337496",
    facebook: "https://www.facebook.com/AventixSC/"
  }
};

export const heroContent = {
  title: "Votre partenaire en gestion de projet TI et affaires",
  subtitle: "Services Conseils Aventix accompagne les entreprises du secteur de l'assurance, de la finance et les PME dans leurs projets de transformation numérique et développement logiciel.",
  cta: "Discutons de votre projet",
  image: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxJVCUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzcyOTg3ODgxfDA&ixlib=rb-4.1.0&q=85"
};

export const aboutContent = {
  title: "À propos d'Aventix",
  description: "Service Conseils Aventix inc. est une entreprise spécialisée dans les services conseils en gestion de projet TI et affaires. Nous intervenons principalement dans le domaine de l'assurance, des finances ainsi qu'auprès des PME en développement logiciel.",
  mission: "Notre mission est d'accompagner nos clients dans la réalisation de leurs projets technologiques et de transformation numérique, en apportant une expertise pointue et des solutions adaptées à leurs besoins spécifiques.",
  values: [
    {
      title: "Excellence",
      description: "Nous visons l'excellence dans chaque projet"
    },
    {
      title: "Expertise",
      description: "Une connaissance approfondie des secteurs d'activité"
    },
    {
      title: "Partenariat",
      description: "Une approche collaborative avec nos clients"
    }
  ]
};

export const services = [
  {
    id: 1,
    title: "Gestion de projet TI",
    description: "Planification, coordination et pilotage de vos projets technologiques pour garantir leur succès dans les délais et budgets établis.",
    icon: "Laptop",
    features: [
      "Planification et coordination de projets",
      "Gestion des risques et des ressources",
      "Suivi et reporting détaillé",
      "Méthodologies agiles et traditionnelles"
    ]
  },
  {
    id: 2,
    title: "Consultation en affaires",
    description: "Analyse et optimisation de vos processus d'affaires pour améliorer l'efficacité opérationnelle et stimuler la croissance.",
    icon: "TrendingUp",
    features: [
      "Analyse de processus d'affaires",
      "Stratégie de transformation numérique",
      "Optimisation opérationnelle",
      "Accompagnement au changement"
    ]
  },
  {
    id: 3,
    title: "Expertise sectorielle",
    description: "Connaissance approfondie des secteurs de l'assurance et de la finance pour des solutions adaptées à vos enjeux spécifiques.",
    icon: "Building2",
    features: [
      "Solutions pour le secteur de l'assurance",
      "Expertise en services financiers",
      "Conformité réglementaire",
      "Gestion de systèmes critiques"
    ]
  },
  {
    id: 4,
    title: "Développement logiciel",
    description: "Conception et développement de solutions logicielles sur mesure adaptées aux besoins des PME et grandes entreprises.",
    icon: "Code",
    features: [
      "Développement d'applications sur mesure",
      "Modernisation de systèmes existants",
      "Architecture logicielle",
      "Support et maintenance"
    ]
  }
];

export const contactFormData = {
  title: "Contactez-nous",
  subtitle: "Discutons de votre projet et de la façon dont nous pouvons vous aider à atteindre vos objectifs.",
  submitSuccess: "Merci pour votre message ! Nous vous contacterons sous peu.",
  submitError: "Une erreur s'est produite. Veuillez réessayer."
};
